import type { AppRouteRecordRaw } from '@/router/types'
import { Layout } from '@/utils/routerHelper'

/** 微场景独立路由组 — 新窗口打开路径：/scene/dashboard */
const microsceneStandaloneRoutes: AppRouteRecordRaw[] = [
  {
    path: '/scene',
    component: Layout,
    redirect: '/scene/dashboard',
    name: 'MicroSceneStandalone',
    meta: { title: '微场景', hidden: true },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/microscene/dashboard/index.vue'),
        name: 'MicroSceneStandaloneDashboard',
        meta: { title: '微场景概况', hidden: true }
      }
    ]
  }
]

export default microsceneStandaloneRoutes
